import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  ApiBlueprint,
  createApiFactory,
  configApiRef,
} from '@backstage/frontend-plugin-api';

export const scmIntegrationsApiExtension = ApiBlueprint.make({
  name: 'scm-integrations',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: scmIntegrationsApiRef,
        deps: { configApi: configApiRef },
        factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
      }),
    ),
});

export const scmAuthApiExtension = ApiBlueprint.make({
  name: 'scm-auth',
  params: defineParams => defineParams(ScmAuth.createDefaultApiFactory()),
});
